import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
// import { AlertTriangleOutline } from '@lyearn/icons';
import { Stack, Typography } from '@lyearn/ui';

function AiWarning({ className }: { className?: string }) {
  const { t } = useTranslation(['AI']);
  const { isMobile } = useScreen();
  return (
    <Stack
      alignItems="center"
      className={cn('rounded-8 w-full text-center', className, isMobile ? 'p-0' : 'p-12')}
      direction="row"
      gap={12}
      justifyContent="center">
      {/* <AlertTriangleOutline fillColorToken="icon-primary" height={16} width={16} /> */}
      <Typography
        className="text-center"
        color="text-text-secondary"
        variant={isMobile ? 'body-short-04' : 'body-short-03'}>
        {t('AI:AICanMakeMistakes')}
      </Typography>
    </Stack>
  );
}

export default AiWarning;
